require('./promoController');

"use strict";

angular.module('app.promo', ['app.promo.promoController'])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {
      
      let logTemplate = 'components/promo/promoView.html';

      $stateProvider.state('app.promo', {
        url: '/under-the-tree',
        templateUrl: logTemplate,
        controller: 'app.promo.promoController',
        title: 'HockeyTV Under The Tree',
        noSidebar: true,
        noTitleBar: true
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/promo/promo.js